<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M9.08333 3.3335L13.75 8.00015L9.08333 12.6668M2.25 8.00015L13.3333 8.00016"
    stroke="currentColor"
    stroke-width="1.5"
  />
</svg>
